import { ReferenceInput, AutocompleteInput } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { useWatch } from "react-hook-form";

const DepartmentInput = ({ readOnly = false, ...rest }) => {
  const directionId = useWatch({ name: "directionId" });

  return (
    <ReferenceInput
      source="departmentId"
      filter={{ filterByUser: true, directionId: directionId }}
      reference={administrationRequests.getDepartmentsSelect()}
      {...rest}
    >
      <AutocompleteInput
        label="Катедра"
        disabled={!directionId}
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        readOnly={readOnly}
        emptyText="Всички"
      />
    </ReferenceInput>
  );
};

export default DepartmentInput;
